import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

const QuickReplyBlock = observer(({ block }) => {
  const answered = Boolean(block.selectedValue);

  return (
    <div className={`copilotQuickReplies ${answered ? "answered" : ""}`}>
      {block.prompt && (
        <div className="copilotQuickReplies__prompt">{block.prompt}</div>
      )}
      <div className="copilotQuickReplies__options">
        {(block.options || []).map(option => {
          const isSelected = block.selectedValue === option.value;
          return (
            <button
              type="button"
              key={option.value}
              className={`copilotQuickReplies__option ${
                isSelected ? "selected" : ""
              }`}
              disabled={answered || copilotStore.streaming}
              onClick={() => copilotStore.selectQuickReply(block.id, option)}
            >
              <span className="copilotQuickReplies__optionLabel">
                {option.label}
              </span>
              {option.description && (
                <span className="copilotQuickReplies__optionDesc">
                  {option.description}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
});

export default QuickReplyBlock;
